import React from 'react';
import Helmet from 'react-helmet';

import generateData from './metadata';

const Meta = props => (
  <Helmet {...generateData(props)} />
);

export default Meta;



// WEBPACK FOOTER //
// ./src/@ui/Meta/index.web.js